/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartNumberChangesDetailComponent} from './part-number-changes-detail.component';
import {PartNumberChangesDetailTitleModule} from '../part-number-changes-title/part-number-changes-detail-title.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {PartNumberChangeDetailFooterModule} from '../part-number-changes-footer/part-number-change-detail-footer.module';
import {PartNumberChangesOldCredentialsModule} from '../part-number-changes-old-credentials/part-number-changes-old-credentials.module';
import {PartNumberChangesDetailSolutionModule} from '../part-number-changes-solution/part-number-changes-detail-solution.module';
import {PartNumberChangesDetailHeaderComponent} from '../part-number-changes-header/part-number-changes-detail-header.component';
import {PartNumberChangesDetailStickyHeaderComponent} from '../part-number-changes-sticky-header/part-number-changes-detail-sticky-header.component';
import {SwitchButtonModule} from '../../shared/switch-button/switch-button.module';
import {UndefinedValuePipe} from '../../shared/pipes/undefined-value/undefined-value.pipe';
import {PrettyPrintMaterialNumberPipe} from '../../shared/pipes/pretty-print-material-number/pretty-print-material-number.pipe';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {FlyingMenuModule} from '../../shared/flying-menu/flying-menu.module';
import {PartNumberChangesAiSolutionModule} from '../part-number-changes-ai-solution/part-number-changes-ai-solution.module';
import {PartNumberChangesCancellationModule} from '../part-number-changes-cancellation/part-number-changes-cancellation.module';
import {
    PartNumberChangeDetailSolutionTrialModule
} from '../part-number-changes-solution/part-number-change-detail-solution-trial/part-number-change-detail-solution-trial.module';

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        SwitchButtonModule,
        PartNumberChangesDetailTitleModule,
        PartNumberChangeDetailFooterModule,
        PartNumberChangesOldCredentialsModule,
        PartNumberChangesDetailSolutionModule,
        PartNumberChangesAiSolutionModule,
        PartNumberChangesCancellationModule,
        PartNumberChangeDetailSolutionTrialModule,
        TooltipModule,
        FlyingMenuModule
    ],
    declarations: [PartNumberChangesDetailComponent, PartNumberChangesDetailHeaderComponent, PartNumberChangesDetailStickyHeaderComponent],
    exports: [PartNumberChangesDetailComponent],
    providers: [UndefinedValuePipe, PrettyPrintMaterialNumberPipe]
})
export class PartNumberChangesDetailModule {
}
